import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Badge,
  Avatar,
  Input,
  Comment,
  Checkbox,
} from "antd";
import "./MsCard.css";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import moment from "moment";

export default function MsCard({ item, isSpend, settotalPaid, totalPaid }) {

  const [imageUrl, setimageUrl] = useState("");
  const [totalAmount, setTotalAmount] = useState(0)
  // const [checked, setchecked] = useState(false)
  

  useEffect(() => {
    getPicture(item?.user[0]?.profile?.PictureUrl);
  }, []);


const updateTotal=(e, amount) =>{
// setchecked(!checked)
//   setTotalAmount((totalAmount) => {   
//     if (checked) {
//       totalAmount = totalAmount + amount;
//       return totalAmount
//     } else {
//       totalAmount = totalAmount - amount;
//       return totalAmount
//     }
//     console.log("total amount is ", totalAmount)
//   });
// console.log("check val is ",checked)
if (e.target.checked){
settotalPaid(totalPaid+amount)
}
else{
  settotalPaid(totalPaid-amount)
}
}

  const getPicture = (Key) => {
    var url = Key;
    if (url !== null) {
      // var key = imageURLSplit(url);
      getImage(url)
        .then((result) => {
          // console.log("profile picture: ", result);
          setimageUrl(result);
        })
        .catch(() => {
        });
    } else {
    }
  };

  return (
    <div className="msCard" >
      <div className="mscard-divider"></div>
      <Row
        className="interview-card"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <Col span={18}>
          <Row>
            {isSpend === "Pending" ? (
              <div className="paymentCheckBox">
                <Checkbox 
                onChange={ (e)=> updateTotal(e,item.Amount)}
                />
              </div>
            ) : null}
            <Comment
              className="ms-comment-style"
              author={
                <div className="mscard-title">
                  {item?.user[0]?.profile?.FirstName}{" "}
                  {item?.user[0]?.profile?.LastName}
                </div>
              }
              avatar={
                <Badge dot={true} status={"success" || "default"}>
                  <Avatar
                    // src="https://joeschmoe.io/api/v1/random"
                    src={imageUrl}
                    alt="Han Solo"
                  />
                </Badge>
              }
              content={
                <>
                  <div className="mscard-content">
                    <div>{item?.skill_lisitng[0]?.Title}</div>
                    <div>{item?.gig[0]?.Title}</div>
                    {/* <span className="mscard-time">2/14/2022-2/18/2022</span> */}
                    <span className="mscard-time">
                      {moment(item?.Created).format("MMMM DD, YYYY")} -{" "}
                      {moment(item?.ExpiryDate).format("MMMM DD, YYYY")}
                    </span>
                  </div>
                  <div className="mscard-rate-upper">
                    $ {item.Amount}
                  </div>
                  
                  {isSpend === "Paid" ? (
                    <Button className="mscard-btn">Download receipt</Button>
                  ) : null}
                </>
              }
            />
          </Row>
        </Col>
        <Col span={6} className="mscard-rate">
          $ {item.Amount}
        </Col>
      </Row>
    </div>
  );
}
